var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16.755V1.245C3 1.11372 3.0507 0.987813 3.14095 0.894982C3.23121 0.802152 3.35361 0.75 3.48125 0.75H12.8271C12.9547 0.750116 13.077 0.802343 13.1672 0.8952L15.6922 3.4923C15.7371 3.53842 15.7726 3.59321 15.7969 3.65353C15.8211 3.71384 15.8335 3.77849 15.8333 3.84375V16.755C15.8333 16.82 15.8209 16.8844 15.7967 16.9444C15.7725 17.0045 15.7371 17.0591 15.6924 17.105C15.6477 17.151 15.5946 17.1874 15.5363 17.2123C15.4779 17.2372 15.4153 17.25 15.3521 17.25H3.48125C3.41805 17.25 3.35547 17.2372 3.29708 17.2123C3.2387 17.1874 3.18564 17.151 3.14095 17.105C3.09627 17.0591 3.06082 17.0045 3.03663 16.9444C3.01245 16.8844 3 16.82 3 16.755Z",
    stroke: "#6E8CA0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.625 0.75V3.555C12.625 3.68628 12.6757 3.81219 12.766 3.90502C12.8562 3.99785 12.9786 4.05 13.1063 4.05H15.8333",
    stroke: "#6E8CA0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.7e2ec636c9a214cf8749d4fcd52282fe.svg";
export { ForwardRef as ReactComponent };